/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  GET_ACCOUNTS,
  GET_ACCOUNTS_SUCCESS,
  GET_ACCOUNTS_FAILURE,
  ADD_ACCOUNT,
  ADD_ACCOUNT_SUCCESS,
  ADD_ACCOUNT_FAILURE,
  REMOVE_ACCOUNT,
  REMOVE_ACCOUNT_SUCCESS,
  REMOVE_ACCOUNT_FAILURE
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse
} from "./reducerUtils";

const initialState = {
  data: null,
  state: "INIT",
  error: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADD_ACCOUNT:
      return setLoadingState(state, "", "ADD");
    case ADD_ACCOUNT_SUCCESS:
      return setSuccessResponse(state, action, "", "ADD");

    case ADD_ACCOUNT_FAILURE:
      return setErrorResponse(state, action.err, "", "ADD");

    case GET_ACCOUNTS:
      return setLoadingState(state, "", "GET");

    case GET_ACCOUNTS_SUCCESS:
      return setSuccessResponse(state, action, "", "GET");

    case GET_ACCOUNTS_FAILURE:
      return setErrorResponse(state, action.err, "", "GET");

    case REMOVE_ACCOUNT:
      return setLoadingState(state, "", "REMOVE");

    case REMOVE_ACCOUNT_SUCCESS:
      return setSuccessResponse(state, action, "", "REMOVE");

    case REMOVE_ACCOUNT_FAILURE:
      return setErrorResponse(state, action.err, "", "REMOVE");

    default:
      return state;
  }
}
